module.exports = __webpack_public_path__ + "static/holiday-inn.8efab6fa.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/holiday-inn.png
// module id = 501
// module chunks = 35783957827783